import { translate } from "@classdojo/web/utils/translate";

export type ErrorType = "NotSupportedError" | "NotFoundError" | "NotAllowedError" | "UnknownError";

export default (errorType: string) => {
  switch (errorType) {
    case "NotSupportedError":
      return translate("dojo.toolkit:noise_meter.errors.not_supported");
    case "NotFoundError":
      return translate("dojo.toolkit:noise_meter.errors.not_found");
    case "NotAllowedError":
      return translate("dojo.toolkit:noise_meter.errors.not_allowed");
    case "UnknownError":
      return translate("dojo.toolkit:noise_meter.errors.unknown");
  }
};
